export const sizes = {
  navBarHeight: '64px',
  drawerWidth: 280,
  formRowGap: 5,
  formColumnGap: 3,
};
